import { NgxsConfig } from '@ngxs/store';
import { NgxsDevtoolsOptions } from '@ngxs/devtools-plugin';

// Env
import { environment } from '@env';

// Store states
import { AuthState } from './auth/auth.state';
import { UIState } from './app/states/ui/ui.state';
import { UserState } from './app/states/user/user.state';
import { IncidentsState } from './app/states/incidents/incidents.state';
import { RimsState } from './app/states/rims/rims.state';
import { IncidentAnalyticsState } from './app/states/analytics/analytics.state';

export const STATES_MODULES = [UIState, UserState, IncidentsState, RimsState, IncidentAnalyticsState, AuthState];

export const OPTIONS_CONFIG: Partial<NgxsConfig> = {
  developmentMode: !environment.isProduction,
};

export const DEVTOOLS_REDUX_CONFIG: NgxsDevtoolsOptions = {
  disabled: !!environment.isProduction,
};
